/** Payments API calls (typed). */

import { apiDelete, apiGet, apiPatch, apiPost, type PaginatedResponse, type QueryParams } from "@/lib/api-client";
import type { ApiPayment } from "./payments.adapter";

export interface PaymentsListParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: string; // a concrete PaymentStatus (never "all")
  type?: string;
  method?: string;
  archived?: boolean;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export const paymentsApi = {
  list: (params: PaymentsListParams = {}) =>
    apiGet<PaginatedResponse<ApiPayment>>("/payments", params as QueryParams),
  getById: (id: string) => apiGet<ApiPayment>(`/payments/${id}`),
  create: (body: Record<string, unknown>) => apiPost<ApiPayment>("/payments", body),
  update: (id: string, body: Record<string, unknown>) => apiPatch<ApiPayment>(`/payments/${id}`, body),
  archive: (id: string) => apiDelete<ApiPayment>(`/payments/${id}`),
  restore: (id: string) => apiPost<ApiPayment>(`/payments/${id}/restore`),
};
